import React from 'react';

const NotFound = (props) => <h2>oops!</h2>;

export default NotFound;
